import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { MilitaryKind } from "../../../../define/MilitaryKind";
import NormalGameManager from "../../../manager/NormalGameManager";
import UserDataManage from "../../UserDataManage";
import MilitaryCityData from "./MilitaryCityData";
import MilitaryNewCityListData from "./MilitaryNewCityData";

export default class MilitaryCityDataManage {

    militaryCityData = new MilitaryCityData();
    // militaryNewCityListData = new MilitaryNewCityListData();
 
    loadLocationData() {
        this.militaryCityData.loadLocalData();
        // this.militaryNewCityListData.loadLocalData();
    }

    saveAllLocationData() {
        this.militaryCityData.saveLocalData();
        // this.militaryNewCityListData.saveLocalData();
    }

    /**
     * 每天数据处理
     */
    dayDataDispose() {
        // let curTime = Date.now();
        let militaryOfficerDataManage = UserDataManage.instance.militaryOfficerDataManage;
        let militaryOfficerData = militaryOfficerDataManage.militaryOfficerData;

        let csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.CITY);
        let csvOfficer = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.OFFICER);
        let DROP_CITY_REFRESH_DAY = MilitaryKind.GeneralValue.DROP_CITY_REFRESH_DAY;
        let curTime = NormalGameManager._instance.getCurrentDay();
        let title = csvInfo.title;
        let titleOfficer = csvOfficer.title;

        let bSaveCity = false;
        let bSaveOfficer = false;
        this.militaryCityData.lists.forEach((v, k)=> {
            if (v.bDrop) {
                return;
            }
            let info = csvInfo[v.id];
            if (!info) {
                console.error(`未找到城市数据 id = ` + v.id);
                return;
            }

            let spaceTime = curTime - v.lastDropTime;
            let spaceTimeEarning = curTime - v.lastRecvAwardTime;
            let bCalcDrop = spaceTime >= DROP_CITY_REFRESH_DAY;
            let eraning_hz = Number(info[title.eraning_hz]);
            let bCalcEarning = spaceTimeEarning >= eraning_hz;
            if (!bCalcDrop && !bCalcEarning) {
                return;
            }

            bSaveCity = true;
            if (bCalcDrop) {
                v.lastDropTime = curTime;
            }

            let officerId = v.officerId;
            let bDrop = true;
            let retEaring = 0;
            if (utilsModel.isValidNumberValue(officerId)) {
                let infoOfficer = csvOfficer[officerId];
                if (!infoOfficer) {
                    console.error(`未找到武将数据 id = ` + officerId);
                    return;
                }

                let officerData = militaryOfficerData.lists.get(officerId);
                let bExclusive = infoOfficer[titleOfficer.exclusive_city] == v.id;
                retEaring = bExclusive ? 
                    Number(infoOfficer[titleOfficer.exclusive_eraning_promote]) 
                    : Number(infoOfficer[titleOfficer.eraning_promote])
                ;
                if (bCalcDrop) {
                    let retGarrison = bExclusive ? 
                        Number(infoOfficer[titleOfficer.exclusive_garrison]) 
                        : Number(infoOfficer[titleOfficer.garrison])
                    ;
                    retGarrison += officerData.addGarrison;

                    bDrop = !data_control.isHitProbability(retGarrison);
                    if (bDrop) {
                        officerData.bDrop = true;
                        bSaveOfficer = true;
                    }
                }
                
            }
            if (bCalcDrop && bDrop) {
                v.bDrop = true;
                O1HD.emit(MessageEventKind.EventName.REFRESH_CITY_DROP_STATE, v.id);
                bCalcEarning = true;

                spaceTimeEarning = curTime - v.lastRecvAwardTime;
            }
            if (bCalcEarning) {
                v.lastRecvAwardTime = curTime;
                
                let day_eraning = Number(info[title.day_eraning]);
                let day_eraning_goods = info[title.day_eraning_goods];
                day_eraning = Math.floor(day_eraning * (1+retEaring) * (spaceTimeEarning / eraning_hz));

                let earningGoods = this.militaryCityData.earningGoods;
                let earningGoodsCount = this.militaryCityData.earningGoodsCount;
                
                let eIdx = earningGoods.indexOf(day_eraning_goods);
                if (eIdx != -1) {
                    earningGoodsCount[eIdx] += day_eraning;
                } else {
                    earningGoods.push(day_eraning_goods);
                    earningGoodsCount.push(day_eraning);
                }
            }
        });
        
        if (bSaveCity) {
            this.militaryCityData.saveLocalData();
        }
        if (bSaveOfficer) {
            militaryOfficerData.saveLocalData();
        }
    }

    recvCompensate() {
        // let militaryNewCityListData = this.militaryNewCityListData
        // if (militaryNewCityListData.bRecvCompensate) {
        //     return;
        // }

        let csvInfo = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.CITY);
        if (!csvInfo) {
            console.error(`CITY 数据未找到`);
            return;
        }
        let title = csvInfo.title;
        let totalPrice = 0;
        this.militaryCityData.lists.forEach((v,k)=> {
            if (v.bDrop) {
                return;
            }
            let info = csvInfo[k];
            if (!info) {
                console.error(`CITY 数据未找到 k = `+k);
                return;
            }
            
            let price = utilsModel.csvNumberParse(info[title.price]);
            totalPrice += price;
        });

        let militaryOfficerData = UserDataManage.instance.militaryOfficerDataManage.militaryOfficerData;
        // 武将返还金币
        if (militaryOfficerData.lists.size > 0) {
            totalPrice += 100000000;
        }

        // 补偿道具
        let propList = {
            '11001': 10,
            '11002': 10000,
            '11003': 10,
            '11004': 4,
            '11005': 1000,
            '11006': 40,
            '11007': 10,
        }
        for (let i in propList) {
            let c = propList[i];
            NormalGameManager._instance.onPushGoods(Number(i), c);
        }

        O1HD.getServices().userSrv.setCoins(totalPrice, true);

        // militaryNewCityListData.bRecvCompensate = true;
        // militaryNewCityListData.saveLocalData();
    }
}
